import { useEffect } from 'react';
import { useDetectOutsideClick } from '../../utils/useDetectOutsideClick';
import { useSelector } from 'react-redux';

function useDetectOutsideHook({
    ref,
    isModalOpen,
    handleCancel
}) {
    const [isActive, setIsActive] = useDetectOutsideClick(ref, false);
    const { workspace_id } = useSelector(state => state.card_duplicate);

    useEffect(() => {
        setIsActive(isModalOpen);
    }, [isModalOpen]);

    useEffect(() => {
        if (isActive) {

        } else if (workspace_id)  {
            handleCancel();
        }
    }, [isActive]);
}

export default useDetectOutsideHook;